// OtherCalculator.js
import React from "react";
import { otherCalculators } from "./ConstantsOtherCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Lainnya";
const DESCRIPTION = "Kalkulator Lainnya";
const KEYWORDS = "Kalkulator Lainnya";
const OG_URL = 'https://do-calculate.com/id/other-calculators';
function CalculatorsList() {
  return (
    <div className="container ltr-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >Kalkulator</th>
            <th >Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          {otherCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default CalculatorsList;